import React, {useEffect, useState} from "react";
import styles from "./HeaderErrorBar.module.scss";

const HeaderErrorBar = ({ children, showError }) => {

    const [show, setShow] = useState();

    useEffect(() => {
        setShow(showError);
    }, [showError])

    if (show) {
        return (
            <div className={`d-flex align-items-center justify-content-between ${styles.HeaderErrorBar}`}>
                <div>
                    { children }
                </div>
                <div onClick={() => setShow(false)} className={'d-flex align-items-center'}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="12.666" y1="4.39399" x2="4.39334" y2="12.6667" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M3.95508 3.95554L12.6284 12.6289" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </div>
            </div>
        )
    } else {
        return null;
    }
}

export default HeaderErrorBar;